import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Evented.js";
import o from "../../core/Handles.js";
import { isSome as i } from "../../core/maybe.js";
import { watch as n, pausable as s } from "../../core/watchUtils.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";

var c = /*#__PURE__*/function (_t$EventedAccessor) {
  _inherits(c, _t$EventedAccessor);

  var _super = _createSuper(c);

  function c(e) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e), _this._anchorHandles = new o(), _this.location = null, _this.screenLocation = null, _this.screenLocationEnabled = !1, _this.view = null, _this._anchorHandles.add([n(_assertThisInitialized(_this), ["screenLocationEnabled", "location", "view.size", "view.stationary"], function () {
      return _this._updateScreenPointAndHandle();
    }), n(_assertThisInitialized(_this), ["view", "view.ready"], function () {
      return _this._wireUpView();
    })]);
    return _this;
  }

  _createClass(c, [{
    key: "destroy",
    value: function destroy() {
      this.view = null, this._anchorHandles && this._anchorHandles.destroy(), this._anchorHandles = null, this._viewpointHandle = null;
    }
  }, {
    key: "_wireUpView",
    value: function _wireUpView() {
      var _this2 = this;

      var e = "view";
      this._anchorHandles.remove(e), this._viewpointHandle = null;
      if (!this.get("view.ready")) return;

      this._setScreenLocation();

      var t = this.view,
          o = "3d" === t.type ? "camera" : "viewpoint",
          i = s(t, o, function () {
        return _this2._viewpointChange();
      });
      this._anchorHandles.add(i, e), this._viewpointHandle = i, this._toggleWatchingViewpoint();
    }
  }, {
    key: "_viewpointChange",
    value: function _viewpointChange() {
      this._setScreenLocation(), this.emit("view-change");
    }
  }, {
    key: "_updateScreenPointAndHandle",
    value: function _updateScreenPointAndHandle() {
      this._setScreenLocation(), this._toggleWatchingViewpoint();
    }
  }, {
    key: "_toggleWatchingViewpoint",
    value: function _toggleWatchingViewpoint() {
      var e = this._viewpointHandle,
          t = this.location,
          o = this.screenLocationEnabled;
      if (!e) return;
      t && o ? e.resume() : e.pause();
    }
  }, {
    key: "_setScreenLocation",
    value: function _setScreenLocation() {
      var e = this.location,
          t = this.view,
          o = this.screenLocationEnabled,
          n = this.get("view.ready"),
          s = o && n && i(e) ? t.toScreen(e) : null;

      this._set("screenLocation", s);
    }
  }]);

  return c;
}(t.EventedAccessor);

e([r()], c.prototype, "location", void 0), e([r({
  readOnly: !0
})], c.prototype, "screenLocation", void 0), e([r()], c.prototype, "screenLocationEnabled", void 0), e([r()], c.prototype, "view", void 0), c = e([a("esri.widgets.support.AnchorElementViewModel")], c);
var l = c;
export { l as default };